import React from 'react';
import { StorefrontHeader } from './StorefrontHeader';
import { StorefrontFooter } from './StorefrontFooter';
interface StorefrontLayoutProps {
  children: React.ReactNode;
  storeName: string;
  storeSlug: string;
  organizationName: string;
  supportEmail: string;
  supportPhone?: string;
}
export function StorefrontLayout({
  children,
  storeName,
  storeSlug,
  organizationName,
  supportEmail,
  supportPhone
}: StorefrontLayoutProps) {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-246">
      <StorefrontHeader storeName={storeName} storeSlug={storeSlug} organizationName={organizationName} data-id="element-247" />
      <main className="flex-1" data-id="element-248">{children}</main>
      <StorefrontFooter supportEmail={supportEmail} supportPhone={supportPhone} data-id="element-249" />
    </div>;
}